// import Store from 'store/store';
import cached from 'utils/cached';
import { api } from 'utils/bolt/api';
import { asList } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt';

// Not waiting, we just want whatever is available
const currentLocationOptions = async () => {
	// Should we use geo from ip or the current location?
	// let geo = accessNested(Store.get(), 'client.geo') || {};
	// return { lat: geo.lat, lon: geo.lon };
	try {
		const geo = await geoFromIP();
		return { lat: geo.lat, lon: geo.lon };
	} catch (err) {
		return {};
	}
};

// const getDefaultRegionBiasing = cached(() => {
// 	// let region = (await geoFromIP()).countryCode;
// 	let region = __REGION__;
// 	// Special cases (ccTLD, not ISO ; see https://developers.google.com/maps/documentation/geocoding/intro#RegionCodes)
// 	if (region === 'gb') {
// 		region = 'uk';
// 	}
// 	if (!/^[a-z]{2}$/.test(region)) {
// 		return;
// 	}
// 	return { region };
// });

export const geoFromIP = cached(async () => {
	let result = await fetch('https://stdata.powster.com/geo');
	let data = await result.json();
	if (data?.countryCode) {
		data.countryCode = data.countryCode.toLowerCase();
	}
	return data;
});

export async function geoSearch(options) {
	const allAllowedRegions = [__REGION__, ...asList(getShowtimesData().boundingRegions)].map(s => s.toUpperCase());

	options = Object.assign({
		region: allAllowedRegions.join(',')
	}, await currentLocationOptions(), options);
	if (!options.search) {
		throw new Error('Searching with empty value');
	}

	const data = await api('/geo/search', options);

	if (!data?.response) {
		throw new Error('Unable to search for ' + options.search);
	}

	return data.response.sort((a, b) => {
		let aAllowed = allAllowedRegions.includes(a.countryCode);
		let bAllowed = allAllowedRegions.includes(b.countryCode);
		if (aAllowed && !bAllowed) {
			return -1;
		}
		if (!aAllowed && bAllowed) {
			return 1;
		}
		return 0;
	});
}
export async function geoSearchOne(options) {
	let res = await geoSearch(options);
	if (!res?.[0]) {
		throw new Error('No results for ' + options.search);
	}
	return res[0];
}